import { httpGet } from '../http'
import type { ICountry, IState } from '~/types/country/models'
import { State } from '~/cynqueModules/dataObjects/State'
import { Country } from '~/cynqueModules/dataObjects/Country'

const apiEntityPath = '/api/countries'

export enum CountryIds {
  AUSTRALIA = 14,
  CANADA = 39,
  DENMARK = 59,
  FRANCE = 75,
  GERMANY = 82,
  HONG_KONG_SAR = 98,
  INDIA = 101,
  JAPAN = 109,
  ITALY = 107,
  MEXICO = 142,
  NETHERLANDS = 156,
  PHILIPPINES = 174,
  POLAND = 176,
  SINGAPORE = 199,
  SWEDEN = 213,
  SWITZERLAND = 214,
  UNITED_KINGDOM = 232,
  UNITED_STATES = 233,
}

export async function getCountries({ apiPath = apiEntityPath } = {}) {
  const callingMn = getCountries.name
  return httpGet<ICountry[]>({ callingMn, apiPath })
}

export async function getCountry(id: number) {
  const callingMn = getCountry.name
  const apiPath = `${apiEntityPath}/${id}`
  const rawCountry = await httpGet<ICountry>({ callingMn, apiPath })
  // Through Country() so the result is select-item-shaped (it needs a `label`),
  // matching what setItemsForSelect builds for this field's items. Its one
  // caller is the address block's `country` default value, which is asserted
  // against isSelectItem. Same treatment getStatesForCountry gives State().
  return Country(rawCountry)
}

export async function getStatesForCountry(id: number) {
  const callingMn = getStatesForCountry.name
  const apiPath = `${apiEntityPath}/${id}/states`
  const rawStates = await httpGet<IState[]>({ callingMn, apiPath })
  return rawStates.map((rawState) => Object.assign(rawState, State(rawState)))
}
